import './Header.css';
import React from 'react';

const Header = () => {
    return (
        <div className="header">
            <h1>BPL Player Auction</h1>
        </div>
    );
};

export default Header;